import { useState } from 'react';
import { Wheel } from 'react-custom-roulette';

const SimpleRouletteWheel = () => {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [result, setResult] = useState<number | null>(null);

  const wheelData = [
    {
      option: '1',
      style: { backgroundColor: '#FF6B6B', textColor: '#ffffff' },
    },
    {
      option: '2',
      style: { backgroundColor: '#4ECDC4', textColor: '#ffffff' },
    },
    {
      option: '3',
      style: { backgroundColor: '#96CEB4', textColor: '#ffffff' },
    },
    {
      option: '4',
      style: { backgroundColor: '#DDA0DD', textColor: '#ffffff' },
    },
    {
      option: '5',
      style: { backgroundColor: '#FF69B4', textColor: '#ffffff' },
    },
  ];

  const handleSpinClick = () => {
    if (!mustSpin) {
      const newPrizeNumber = Math.floor(Math.random() * 5);
      setPrizeNumber(newPrizeNumber);
      setMustSpin(true);
    }
  };

  const handleStopSpinning = () => {
    setMustSpin(false);
    setResult(prizeNumber + 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-pink-100 flex flex-col items-center justify-center p-2">
      <div className="w-full text-center">
        <div className="flex justify-center items-center mb-2">
          <h1 className="text-2xl md:text-4xl font-bold text-gray-800 text-center">
            Combien de KOST Ramen ?
          </h1>
        </div>

        <style>{`
          .parent-container {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          .parent-container > div {
            height: 90vmin !important;
            width: 90vmin !important;
            max-height: unset !important;
            max-width: unset !important;
          }
        `}</style>

        {/* Wheel */}
        <div className="relative mb-4 flex justify-center">
          <div className="w-[90vmin] h-[90vmin] parent-container">
            <Wheel
              mustStartSpinning={mustSpin}
              prizeNumber={prizeNumber}
              data={wheelData}
              onStopSpinning={handleStopSpinning}
              backgroundColors={['#3e3e3e', '#df3428']}
              textColors={['#ffffff']}
              outerBorderColor="#eeeeee"
              outerBorderWidth={15}
              innerBorderColor="#30261a"
              innerBorderWidth={0}
              innerRadius={0}
              radiusLineColor="#eeeeee"
              radiusLineWidth={2}
              fontSize={20}
              textDistance={60}
            />
          </div>
        </div>

        {/* Result */}
        {result && (
          <div className="mb-8 p-6 bg-white rounded-lg shadow-lg border-2 border-gray-200 mx-4 text-center">
            <h2 className="text-2xl font-bold text-gray-700 mb-2">
              Résultat :
            </h2>
            <div className="text-6xl md:text-8xl font-bold text-purple-600">
              {result}
            </div>
          </div>
        )}

        {/* Controls */}
        <div className="space-y-4 px-4 flex justify-center">
          <button
            onClick={handleSpinClick}
            disabled={mustSpin}
            className={`px-8 py-4 text-lg md:text-xl font-bold rounded-lg shadow-lg transition-all duration-200 ${
              mustSpin
                ? 'bg-gray-400 cursor-not-allowed text-gray-600'
                : 'bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white transform hover:scale-105'
            }`}
          >
            {mustSpin ? 'En cours...' : 'Faire tourner la roulette !'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleRouletteWheel;
